import { render, staticRenderFns } from "./CenterHeader.vue?vue&type=template&id=34885b2b&scoped=true&"
import script from "./CenterHeader.vue?vue&type=script&lang=ts&"
export * from "./CenterHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CenterHeader.vue?vue&type=style&index=0&id=34885b2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34885b2b",
  null
  
)

export default component.exports